/**
 * @desc 获取年度销售计划指标
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 年度 */
  dateDim: string;
  /** 类型 */
  indicatorType: string;
}

export function request(
  params: Params,
): Promise<
  defs.StandardReturn<Array<defs.QueryPlanSaleYearIndicatorResponse>>
> {
  return defHttp.post({
    url: '/wap/sale/indicator/search',

    params,
  });
}

export function mock(
  params: Params,
): Promise<
  defs.StandardReturn<Array<defs.QueryPlanSaleYearIndicatorResponse>>
> {
  return defHttp.post({
    url: '/mock/wap/sale/indicator/search',

    params,
  });
}
